import React, { useState } from "react";
import { Select, Spin, Input } from 'antd';
import debounce from 'lodash/debounce';

const EntitySelector = ({ entity }) => {
  const { id, nombre } = entity || {};
  const [showChangeEntity, setShowChangeEntity] = useState(!id);
  const [selected, setSelected] = useState(id);
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState([]);

  const toggleShowChangeEntity = () => {
    setShowChangeEntity(prevState => !prevState)
  }

  const fetchUser = debounce(value => {
    setFetching(true);

    fetch(`/admin/merchants/fetch.json?q=${value}`)
      .then(response => response.json())
      .then(body => {
        const data = body.map(item => ({
          id: item.id,
          name: item.nombre
        }));

        setData(data);
        setFetching(false);
      });
  }, 500);

  return (
    <>
      {showChangeEntity ? (
        <div>
          <Select
            showSearch
            style={{width: "100%"}}
            defaultValue={[[nombre]]}
            filterOption={(input, option) => 
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(value) => { setSelected(value) }}
            onSearch={fetchUser}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            placeholder={"Seleciona un merchant"}
          >
            {data.map(item =>
              <Select.Option key={item.id} value={item.id}>{`(${item.id}) ${item.name}`}</Select.Option>
            )}
          </Select>
          <Input type="hidden" name="admin_offer[anunciante_id]" value={selected} />
        </div>
      ) : (
          <div>
            <a style={{marginRight: "1rem"}} href={`/admin/merchants/${id}/edit`} target="_blank">{nombre}</a>
            <button onClick={toggleShowChangeEntity}>Cambiar</button>
          </div>
        )
      }
    </>
  );
};

export default EntitySelector;
